import React, { useEffect, useRef, useState } from "react"

import PropTypes from "prop-types"
import { Alert, Col, FormGroup, Input, Label, Row } from "reactstrap"

const AddressForm = ({ onSubmit, onCancel, currentOrder, sameAddress }) => {
  const streetInputRef = useRef(null)
  const numberInputRef = useRef(null)
  const postcodeInputRef = useRef(null)
  const cityInputRef = useRef(null)
  const stateInputRef = useRef(null)
  const complementInputRef = useRef(null)
  const neighborhoodInputRef = useRef(null)
  const noteInputRef = useRef(null)

  const [invalidCep, setInvalidCep] = useState(null)

  const [phone, setPhone] = useState("")

  const [reenvioMesmoEndereco, setReenvioMesmoEndereco] = useState(false)

  useEffect(() => {
    setReenvioMesmoEndereco(sameAddress)
    sameAddress ? setCurrentAddress() : clearCEP()
  }, [])

  const onFormSubmit = e => {
    e.preventDefault()
    const street = streetInputRef.current.value
    const number = numberInputRef.current.value
    const postcode = postcodeInputRef.current.value
    const city = cityInputRef.current.value
    const state = stateInputRef.current.value
    const complement = complementInputRef.current.value
    const neighborhood = neighborhoodInputRef.current.value
    const note = noteInputRef.current.value
    const newAddress = {
      street: street,
      number: number,
      neighborhood: neighborhood,
      postcode: postcode,
      city: city,
      state: state,
      complement: complement,
      anotacao: note,
      sameAddress: reenvioMesmoEndereco,
    }
    const text = `Novo endereço:\nRua: ${street}, ${number}
                                \nBairro: ${neighborhood}
                                \nCEP: ${postcode}
                                \nCidade: ${city} - ${state}
                                \nComplement: ${complement}
                                \n\nAnotações: ${note}
                  `
    // if (typeof onSubmit === "function") onSubmit(newAddress, note)
    if (typeof onSubmit === "function")
      onSubmit({ newAddress: newAddress, sameAddress: reenvioMesmoEndereco })
  }

  const clearCEP = () => {
    streetInputRef.current.value = ""
    numberInputRef.current.value = ""
    cityInputRef.current.value = ""
    stateInputRef.current.value = ""
    complementInputRef.current.value = ""
    neighborhoodInputRef.current.value = ""
    reenvioMesmoEndereco && (postcodeInputRef.current.value = "")
  }

  const setCurrentAddress = () => {
    streetInputRef.current.value = currentOrder?.shippingStreet
    numberInputRef.current.value = currentOrder?.shippingStreetNumber
    cityInputRef.current.value = currentOrder?.shippingCity
    stateInputRef.current.value = currentOrder?.shippingState
    complementInputRef.current.value = currentOrder?.shippingAddressComplement
    neighborhoodInputRef.current.value = currentOrder?.shippingNeighborhood
    postcodeInputRef.current.value = currentOrder?.shippingPostcode
  }

  const checkCep = e => {
    try {
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      }
      const cep = e.target.value.replace(/\D/g, "")
      if (cep !== "") {
        fetch(`https://viacep.com.br/ws/${cep}/json/`)
          .then(res => {
            console.log("res", res)
            if (!res.ok) {
              clearCEP()
              throw new Error(
                "Serviço fora do ar - consultar no site dos Correios."
              )
            }
            return res.json()
          })
          .then(data => {
            if (data?.erro) {
              clearCEP()
              throw new Error("CEP inválido.")
            }
            setInvalidCep(null)
            streetInputRef.current.value = data.logradouro
            neighborhoodInputRef.current.value = data.bairro
            cityInputRef.current.value = data.localidade
            stateInputRef.current.value = data.uf
          })
          .catch(e => {
            setInvalidCep(e.message)
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <form onSubmit={onFormSubmit} className="w-100">
      {invalidCep && (
        <Alert color="warning" role="alert">
          {invalidCep}
        </Alert>
      )}
      {/* <Row>
        <Col>
          <FormGroup check>
            <Input
              type="checkbox"
              onChange={e => {
                setReenvioMesmoEndereco(e.target.checked)
                e.target.checked ? setCurrentAddress() : clearCEP()
              }}
            />
            <Label check>Reenvio para mesmo endereço.</Label>
          </FormGroup>
        </Col>
      </Row> */}
      <Row>
        <Col xs={2}>
          {" "}
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>CEP:</Label>
              <Input
                required
                maxLength="8"
                className="form-control-sm"
                innerRef={postcodeInputRef}
                readOnly={reenvioMesmoEndereco}
                onBlur={checkCep}
              />
            </FormGroup>
          </fieldset>
        </Col>
        <Col xs={6}>
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>Rua:</Label>
              <Input
                required
                className="form-control-sm"
                innerRef={streetInputRef}
                readOnly={reenvioMesmoEndereco}
              />
            </FormGroup>
          </fieldset>
        </Col>
        <Col xs={1}>
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>Número:</Label>
              <Input
                required
                className="form-control-sm"
                innerRef={numberInputRef}
                readOnly={reenvioMesmoEndereco}
              />
            </FormGroup>
          </fieldset>
        </Col>
        <Col xs={3}>
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>Complemento:</Label>
              <Input
                required
                className="form-control-sm"
                innerRef={complementInputRef}
                readOnly={reenvioMesmoEndereco}
              />
            </FormGroup>
          </fieldset>
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>Bairro:</Label>
              <Input
                required
                className="form-control-sm"
                innerRef={neighborhoodInputRef}
                readOnly={reenvioMesmoEndereco}
              />
            </FormGroup>
          </fieldset>
        </Col>
        <Col xs={4}>
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>Cidade:</Label>
              <Input
                required
                className="form-control-sm"
                innerRef={cityInputRef}
                readOnly={reenvioMesmoEndereco}
              />
            </FormGroup>
          </fieldset>
        </Col>
        <Col xs={2}>
          <fieldset disabled={reenvioMesmoEndereco}>
            <FormGroup>
              <Label>UF:</Label>
              <Input
                required
                className="form-control-sm"
                innerRef={stateInputRef}
                readOnly={reenvioMesmoEndereco}
              />
            </FormGroup>
          </fieldset>
        </Col>
      </Row>

      <div className="form-group">
        <label>Adicione anotações à solicitação de suporte:</label>
        <textarea className="form-control" rows="5" ref={noteInputRef} />
      </div>
      <div className="form-group d-flex justify-content-between mt-2">
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={e => {
            e.preventDefault()
            if (typeof onCancel === "function") onCancel()
          }}
        >
          Cancelar
        </button>

        <button type="submit" className="btn btn-primary">
          Enviar solicitação
        </button>
      </div>
    </form>
  )
}

AddressForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  currentOrder: PropTypes.any,
  sameAddress: PropTypes.any,
}

export default AddressForm
